export const environment = {
  production: false,
  supabaseUrl: 'https://qmlozchwfhixyuctuiem.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFtbG96Y2h3ZmhpeHl1Y3R1aWVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3MDkwODgsImV4cCI6MjA2MjI4NTA4OH0.s1xraVaAc8w6UwfdZt0OM9e8_ce_rOTxlxrelOQkDps'
};
